import { render, staticRenderFns } from "./Informations.vue?vue&type=template&id=679488d2&scoped=true"
import script from "./Informations.vue?vue&type=script&lang=js"
export * from "./Informations.vue?vue&type=script&lang=js"
import style0 from "./Informations.vue?vue&type=style&index=0&id=679488d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679488d2",
  null
  
)

export default component.exports